import { useState, useEffect } from 'react';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const branches = [
    {
      name: '北海道支部',
      image: 'https://public.readdy.ai/ai/img_res/fbd4ea60651f7fa67aeca9295e47718e.jpg'
    },
    {
      name: '東京支部',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20night%20view%20of%20Tokyo%20cityscape%20with%20illuminated%20skyscrapers%20and%20urban%20lights%2C%20modern%20metropolitan%20skyline%20at%20twilight%20with%20warm%20golden%20and%20blue%20tones%2C%20sophisticated%20architecture%20and%20city%20glow%2C%20professional%20photography%20style&width=400&height=300&seq=tokyo-branch-001&orientation=landscape'
    },
    {
      name: '大阪支部',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20night%20panorama%20of%20Osaka%20city%20with%20glowing%20buildings%20and%20urban%20landscape%2C%20vibrant%20cityscape%20at%20evening%20with%20warm%20amber%20and%20blue%20lighting%2C%20modern%20architecture%20illuminated%20beautifully%2C%20professional%20urban%20photography&width=400&height=300&seq=osaka-branch-001&orientation=landscape'
    },
    {
      name: '名古屋支部',
      image: 'https://readdy.ai/api/search-image?query=Serene%20night%20view%20of%20Nagoya%20city%20skyline%20with%20illuminated%20buildings%20and%20streets%2C%20urban%20landscape%20at%20dusk%20with%20soft%20warm%20and%20cool%20tones%2C%20modern%20architecture%20glowing%20peacefully%2C%20professional%20cityscape%20photography&width=400&height=300&seq=nagoya-branch-001&orientation=landscape'
    },
    {
      name: '福岡支部',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20night%20scene%20of%20Fukuoka%20city%20with%20illuminated%20urban%20landscape%20and%20buildings%2C%20cityscape%20at%20twilight%20with%20warm%20golden%20and%20blue%20lighting%2C%20modern%20architecture%20glowing%20softly%2C%20professional%20photography%20style&width=400&height=300&seq=fukuoka-branch-001&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/872ea2cd-8b23-4b93-8688-7496c667f24a.png" 
              alt="日本音楽会場協会" 
              className="h-10 w-auto"
            />
            <span className={`text-base sm:text-lg font-medium whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              日本音楽会場協会
            </span>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Minimalist%20abstract%20gradient%20background%20with%20deep%20navy%20blue%20and%20dark%20purple%20tones%2C%20subtle%20geometric%20patterns%2C%20professional%20and%20calm%20atmosphere%2C%20modern%20design%20with%20soft%20lighting%2C%20clean%20and%20sophisticated%20style%20for%20official%20organization%20website&width=1920&height=1080&seq=hero-bg-001&orientation=landscape')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        
        <div className="relative z-10 text-center max-w-3xl mx-auto py-20">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8 leading-relaxed">
            日本音楽会場協会は、<br className="sm:hidden" />
            ライブハウス・アーティスト・ファンをつなぐ運営基盤です。
          </h1>
          <p className="text-base sm:text-lg text-white/90 mb-12 leading-relaxed px-4">
            ライブハウスが出演を生み、<br className="hidden sm:block" />
            支部が販売と広報を行い、<br className="hidden sm:block" />
            本部が全体を管理します。
          </p>
          <a 
            href="#branches" 
            className="inline-block bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            全国支部ネットワークを見る
          </a>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-12 text-center">協会の役割</h2>
          
          <div className="space-y-12">
            {/* Introduction */}
            <div className="text-center">
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                日本音楽会場協会は、ライブハウス運営を個別努力から共同基盤へ移行するための運営組織です。<br className="hidden sm:block" />
                本部・支部・会場がそれぞれ役割を分担し、継続可能な活動構造を構築します。
              </p>
            </div>

            {/* 本部の役割 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">本部の役割（統括・仕組み整備）</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                本部は現場運営を行わず、活動基盤の整備に専念します。
              </p>
              <ul className="space-y-2 text-base text-gray-700">
                <li>・全体ルールの策定</li>
                <li>・会場・アーティスト登録管理</li>
                <li>・情報発信基盤の管理</li>
                <li>・販売・決済・会計処理の統一</li>
                <li>・支部運営のサポート</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                本部は「管理機関」ではなく、各地域が活動しやすくなる環境を整える調整機関として機能します。
              </p>
            </div>

            {/* 支部の役割 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">支部の役割（地域運営）</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                支部は地域の活動主体として実務を担当します。
              </p>
              <ul className="space-y-2 text-base text-gray-700">
                <li>・ライブ企画の調整</li>
                <li>・会場スケジュールの取りまとめ</li>
                <li>・チケット販売手続き</li>
                <li>・地域団体・行政との連携</li>
                <li>・イベント企画の実施</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                地域の文化活動は各支部が主体となり、本部は介入せず支援に回ります。
              </p>
            </div>

            {/* 会場の役割 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">会場の役割（活動の中心）</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                ライブハウスは活動の中心として、アーティストと直接連携します。
              </p>
              <ul className="space-y-2 text-base text-gray-700">
                <li>・出演アーティストの調整</li>
                <li>・ライブ運営</li>
                <li>・来場者対応</li>
                <li>・地域文化の発信拠点としての活動</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                会場の裁量を尊重し、統一管理ではなく連携運営を基本とします。
              </p>
            </div>

            {/* アーティストとファンの関係 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">アーティストとファンの関係</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                協会は仲介業ではなく「継続的な活動環境」を提供します。
              </p>
              <ul className="space-y-2 text-base text-gray-700">
                <li>・出演機会の安定化</li>
                <li>・情報発信の一本化</li>
                <li>・安全な来場環境の確保</li>
                <li>・地域を越えた活動機会の創出</li>
              </ul>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                単発イベントではなく、継続的に活動できる音楽環境の形成を目指します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Purpose Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 text-center">協会の目的</h2>
          <div className="space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
            <p>
              日本音楽会場協会は、ライブハウス・アーティスト・ファンを安全かつ持続的につなぐ環境を整備し、地域文化としての音楽活動を継続可能な仕組みとして確立することを目的としています。
            </p>
            <p>
              ライブハウスは単なる興行施設ではなく、地域文化の発信拠点であり、若い才能が成長する社会的な育成の場でもあります。しかし現在は、各会場が個別に運営を行う構造のため、情報共有・人材育成・継続的な活動基盤の確立が困難な状況にあります。
            </p>
            <p>
              本協会は本部と地域支部の連携により、<br />
              ・会場運営の安定化<br />
              ・アーティスト活動機会の継続的創出<br />
              ・ファンとの安全な接点の提供<br />
              を全国規模で実現します。
            </p>
            <p>
              また、行政・教育機関・地域団体と連携し、音楽文化を地域社会へ還元する仕組みを構築することで、ライブハウスを「一過性の娯楽」から「社会に根付く文化基盤」へと発展させていきます。
            </p>
            <p className="font-medium">
              本協会は、音楽を通じて人と地域をつなぎ、持続可能な音楽環境を次世代へ継承することを使命とします。
            </p>
          </div>
        </div>
      </section>

      {/* Branches Network Section */}
      <section id="branches" className="py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-12 text-center">
            全国支部ネットワーク
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {branches.map((branch, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img 
                    src={branch.image}
                    alt={branch.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    {branch.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Participating Venues Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">参加会場</h2>
          <p className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">約200会場</p>
          <p className="text-base text-gray-600">全国で参加</p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-16 text-center">協会参加のメリット</h2>

          <div className="space-y-14">
            {/* ライブハウス */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">ライブハウス</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                出演者の安定確保、販売・受付業務の簡略化、広報の共同化により、個別営業に依存しない年間運営が可能になります。地域外アーティストとの接点も増え、継続的なスケジュール運営へ移行できます。
              </p>
            </div>

            {/* アーティスト */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">アーティスト</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                継続出演機会の確保と活動情報の一括発信により、単発出演ではなく活動基盤としてのライブ出演が可能になります。地域を跨いだ活動機会も生まれ、履歴が蓄積されます。
              </p>
            </div>

            {/* ファン */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">ファン</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                出演情報の一元化とチケット購入の簡略化により、ライブを探す負担が減り、安全に継続して参加できる環境が整います。地域を越えたライブ参加も可能になります。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cost and Distribution Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-12 text-center">運営費と分配の考え方</h2>

          <div className="space-y-8 text-base text-gray-700 leading-relaxed">
            <p>
              本協会は営利団体ではなく、活動が継続するための運営基盤として最小限の管理費のみを設定しています。<br />
              ライブの収益は会場を中心とした活動に還元されることを前提とし、協会は運営を支えるための共通基盤を提供します。
            </p>

            <p>
              運営費は、本部・支部・運営事務の役割に応じて分担され、透明性を重視した仕組みとします。<br />
              収益の主体はあくまでライブハウスと出演者にあり、協会は管理者ではなく環境整備の役割を担います。
            </p>

            <p>
              金額や配分は一律固定ではなく、各会場・企画の特性に応じて調整され、継続的な活動が可能となるバランスを重視します。<br />
              本協会は利益を目的とするものではなく、音楽活動を継続できる仕組みを維持することを目的としています。
            </p>
          </div>
        </div>
      </section>

      {/* Participation Approach Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-base text-gray-700 leading-relaxed text-center">
            <p>
              本協会は一方的な参加募集を目的とするものではなく、各会場・各地域の考え方を尊重しながら形を整えていく仕組みです。<br />
              まずは情報交換としてお気軽にご連絡ください。構想段階からご意見を伺い、地域に合った形を共に検討してまいります。
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">お問い合わせ</h2>
          <div className="space-y-4">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              現在、本サイトは構想共有のための準備ページです。<br />
              正式な協会窓口ではありません。<br />
              内容に関するご連絡は、提案準備担当までお願いいたします。
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-100 py-8 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-sm text-gray-500 mb-3">
            本サイトは構想共有のための試作ページです。正式な協会サイトではありません。
          </p>
          <p className="text-sm text-gray-600">
            © 日本音楽会場協会 All Rights Reserved.
          </p>
          <div className="mt-4">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
